import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class DeviceListStore {
  deviceList = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      deviceList: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getDeviceDetails: action,
      addData: action,
      deleteRecord: action,
      sampleExcel: action,
      addDeviceByExcel: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, total }) {
    this.loading = true;

    var postData = { offset: offset, limit: limit };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=device&a=getDetails", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceList/getDeviceDetails", {
        params: postData,
      });

    this.deviceList = response?.data?.data?.devices;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async deleteRecord({ Id }) {
    var postData = { tokenId: "", Id: Id };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=device&a=delete", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/deviceList/deleteDevice/${Id}`);
    return response;
  }

  async addData(values) {
    var postData = values;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=device&a=update", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/deviceList/createOrUpdateDevice", values);
    return response.data;
  }

  async getDeviceDetails(id) {
    var postData = { id: id, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=device&a=getDetails", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceList/getDeviceDetails", {
        params: postData,
      });

    return response?.data?.data.devices[0];
  }

  async sampleExcel() {
    window.location.href = config.fleetURL + "/appRes/excel/Device_Upload.xlsx";
    // window.location.href =
    // "http://192.168.1.100:8088/awtl_react/public/fleet/appRes/excel/Device_Upload.xlsx";
  }

  // async addDeviceByExcel(excelFile) {
  //   this.excelLoadig = true;
  //   var postData = excelFile;

  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=device&a=deviceexcel", "postData=" + base64Input);
  //   this.excelLoadig = false;
  //   return response.data;
  // }

  async addDeviceByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/deviceList/importDevice", excelFile);
      this.excelLoadig = false;
      return response.data;
    } catch (error) {
      this.excelLoadig = false;
      return error?.response?.data;
    }
  }
}
export default DeviceListStore;
